var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M2 15a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M7 0h5.403a1.8 1.8 0 0 1 1.8 1.8V4h.949c.524 0 .922.47.836.986l-.108.644a7.78 7.78 0 0 1-4.858 5.973l-.106.041a1.44 1.44 0 0 0-.916 1.34V14H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M9.004 0H3.6a1.8 1.8 0 0 0-1.8 1.8V4H.851a.847.847 0 0 0-.835.986l.107.644a7.78 7.78 0 0 0 4.858 5.973l.106.041c.553.215.917.746.917 1.34V14h3z"
  })));
};
export { SvgTrophy as ReactComponent };